import type { CSSProperties } from "react";
// eslint-disable-next-line no-restricted-imports
import moment from "moment";
import type { IntlShape } from "react-intl";

import { LTV_NARROW_CURRENCIES } from "./constants";

export const getRowStyle = (record) => {
  return {
    fontWeight: record["fcp"] === "Average" ? "bold" : "normal",
  } as CSSProperties;
};

export const sortRowsDefault = (rowA, rowB, columnId, desc) => {
  const sortIdStr = `sort_${columnId}`;
  const sortId = rowA.original[sortIdStr] ? sortIdStr : columnId;
  if (rowA.original["fcp"] === "Average") {
    return desc ? 1 : -1;
  }
  if (rowB.original["fcp"] === "Average") {
    return desc ? -1 : 1;
  }
  if (rowA.original[sortId] > rowB[sortId]) {
    return 1;
  }
  if (rowB.original[sortId] > rowA.original[sortId]) {
    return -1;
  }
  return 0;
};

export const getRange = (
  intl: IntlShape,
  earliestMonthQuarter: number,
  earliestYear: number,
  selectedDate: string,
  isStartDate: boolean,
  monthly: boolean
) => {
  const monthMap = getNumMonthMap(intl);

  const todayMonthQuarter = monthly ? moment().month() + 1 : moment().quarter();
  const todayYear = moment().year();

  const selectedDateMonthQuarter = monthly
    ? moment(selectedDate, "YYYY-MM-DD").month() + 1
    : moment(selectedDate, "YYYY-MM-DD").quarter();
  const selectedDateYear = moment(selectedDate, "YYYY-MM-DD").year();

  const startYear = isStartDate ? earliestYear : selectedDateYear;
  const endYear = isStartDate ? selectedDateYear : todayYear;

  const startMonthQuarter = isStartDate ? earliestMonthQuarter : selectedDateMonthQuarter;
  const endMonthQuarter = isStartDate ? selectedDateMonthQuarter : todayMonthQuarter;

  const options = [];

  range(startYear, endYear).forEach((y) => {
    range(y === startYear ? startMonthQuarter : 1, y === endYear ? endMonthQuarter : monthly ? 12 : 4).forEach((m) => {
      options.push({
        id: `${y} - ${monthly ? m : 1 + 3 * (m - 1)}`,
        text: `${y} - ${monthly ? monthMap[m] : m}`,
      });
    });
  });

  return options;
};

export const isNarrowCurrency = (currency: string) => {
  return LTV_NARROW_CURRENCIES.includes(currency);
};

export const getNumMonthMap = (intl: IntlShape) => {
  // these need to be consistent with python strftime %b
  return {
    1: intl.formatMessage({ id: "LTV - Jan", defaultMessage: "Jan" }),
    2: intl.formatMessage({ id: "LTV - Feb", defaultMessage: "Feb" }),
    3: intl.formatMessage({ id: "LTV - Mar", defaultMessage: "Mar" }),
    4: intl.formatMessage({ id: "LTV - Apr", defaultMessage: "Apr" }),
    5: intl.formatMessage({ id: "LTV - May", defaultMessage: "May" }),
    6: intl.formatMessage({ id: "LTV - Jun", defaultMessage: "Jun" }),
    7: intl.formatMessage({ id: "LTV - Jul", defaultMessage: "Jul" }),
    8: intl.formatMessage({ id: "LTV - Aug", defaultMessage: "Aug" }),
    9: intl.formatMessage({ id: "LTV - Sep", defaultMessage: "Sep" }),
    10: intl.formatMessage({ id: "LTV - Oct", defaultMessage: "Oct" }),
    11: intl.formatMessage({ id: "LTV - Nov", defaultMessage: "Nov" }),
    12: intl.formatMessage({ id: "LTV - Dec", defaultMessage: "Dec" }),
  };
};

// Returns an array of numbers from start to end inclusively
export const range = (start, end) => Array.from({ length: end - start + 1 }, (v, k) => k + start);
